const FORMAT_TOKENS: Record<string, (d: Date) => string> = {
	YYYY: (d) => String(d.getFullYear()),
	YY: (d) => String(d.getFullYear()).slice(-2),
	MMMM: (d) => d.toLocaleString("en-US", { month: "long" }),
	MMM: (d) => d.toLocaleString("en-US", { month: "short" }),
	MM: (d) => String(d.getMonth() + 1).padStart(2, "0"),
	M: (d) => String(d.getMonth() + 1),
	DD: (d) => String(d.getDate()).padStart(2, "0"),
	D: (d) => String(d.getDate()),
	HH: (d) => String(d.getHours()).padStart(2, "0"),
	H: (d) => String(d.getHours()),
	hh: (d) => String(d.getHours() % 12 || 12).padStart(2, "0"),
	h: (d) => String(d.getHours() % 12 || 12),
	mm: (d) => String(d.getMinutes()).padStart(2, "0"),
	ss: (d) => String(d.getSeconds()).padStart(2, "0"),
	A: (d) => (d.getHours() < 12 ? "AM" : "PM"),
	a: (d) => (d.getHours() < 12 ? "am" : "pm"),
	dddd: (d) => d.toLocaleString("en-US", { weekday: "long" }),
	ddd: (d) => d.toLocaleString("en-US", { weekday: "short" }),
};

// dddd/ddd must appear before D to avoid partial matches
const TOKEN_REGEX =
	/YYYY|YY|MMMM|MMM|MM|M|DD|D|HH|H|hh|h|mm|ss|A|a|dddd|ddd/g;

/**
 * Formats a date string or Date object using a format string.
 *
 * Supported tokens: YYYY, YY, MMMM, MMM, MM, M, DD, D, HH, H, hh, h, mm, ss, A, a, dddd, ddd
 *
 * @example
 * formatEnDate("2024-06-15", "MMM DD, YYYY") // "Jun 15, 2024"
 * formatEnDate(new Date(), "YYYY-MM-DD")      // "2024-06-15"
 */
export function formatEnDate(value: string | Date, formatStr: string): string {
	const date = typeof value === "string" ? new Date(value) : value;
	if (isNaN(date.getTime())) return "";
	return formatStr.replace(
		TOKEN_REGEX,
		(token) => FORMAT_TOKENS[token]?.(date) ?? token,
	);
}
